import CONSTANTS from '../constants'
import { deleteRequest, getRequest, postRequest, putRequest } from '../../services'
import { APICONFIG } from '../config/apiConfig'
import { addEventLog } from '../../pages/warningCitation/redux/actions/EventsLog'
import { disposeItem, isPermissionExist, sortPortalPermissionByKey } from '../../utils/helper'
// GET VEHICLE LIST DETAILS
export const getVehicleDataList = () => (dispatch) => {
    dispatch(addEventLog('', CONSTANTS.GET_VEHICLE_LIST_REQUEST))
    dispatch({ type: CONSTANTS.GET_VEHICLE_LIST_REQUEST })
    return getRequest(`${APICONFIG.getVehicleListUrl}/page/1`).then((res) => {
        let resObject = res
        dispatch(addEventLog(resObject, CONSTANTS.GET_VEHICLE_LIST_SUCCESS))
        dispatch({ type: CONSTANTS.GET_VEHICLE_LIST_SUCCESS, data: res.data })
        return res.data
    }).catch((err) => {
        let errObject = err
        dispatch(addEventLog(errObject, CONSTANTS.GET_VEHICLE_LIST_FAILURE))
        dispatch({ type: CONSTANTS.GET_VEHICLE_LIST_FAILURE })
        return err
    })
}

// Post Vehicle Details
export const postVehicleList = (data) => (dispatch) => {
    dispatch(addEventLog(data, CONSTANTS.POST_VEHICLE_LIST_REQUEST))
    dispatch({ type: CONSTANTS.POST_VEHICLE_LIST_REQUEST })
    return postRequest(APICONFIG.postVehicleListUrl, data).then((res) => {
        let resObject = { ...data, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.POST_VEHICLE_LIST_SUCCESS))
        dispatch({ type: CONSTANTS.POST_VEHICLE_LIST_SUCCESS, data: res.data })
        return res
    }).catch((err) => {
        let errObject = { ...data, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.POST_VEHICLE_LIST_FAILURE))
        dispatch({ type: CONSTANTS.POST_VEHICLE_LIST_FAILURE })
        return err
    })
}

// Delete Vehicle Details

export const DeleteVehicleList = (id) => (dispatch) => {
    dispatch(addEventLog(id, CONSTANTS.DELETE_VEHICLE_ITEM_REQUEST))
    dispatch({ type: CONSTANTS.DELETE_VEHICLE_ITEM_REQUEST })
    return deleteRequest(`${APICONFIG.deleteVehicleItemUrl}/${id}`).then((res) => {
        let resObject = { ...res, id: id }
        dispatch(addEventLog(resObject, CONSTANTS.DELETE_VEHICLE_ITEM_SUCCESS))
        dispatch({ type: CONSTANTS.DELETE_VEHICLE_ITEM_SUCCESS })
        return res.data
    }).catch((err) => {
        let errObject = { ...err, id: id }
        dispatch(addEventLog(errObject, CONSTANTS.DELETE_VEHICLE_ITEM_FAILURE))
        dispatch({ type: CONSTANTS.DELETE_VEHICLE_ITEM_FAILURE })
        return err
    })
}

// GET VEHICLE DETAILS
// old
// export const getVehicleDetailsList = () => (dispatch) => {
//     dispatch({ type: CONSTANTS.GET_VEHICLE_REQUEST })
//     return getRequest(`${APICONFIG.getVehicleDetailsUrl}`).then((res) => {
//         dispatch({ type: CONSTANTS.GET_VEHICLE_SUCCESS, data: res.data })
//         return res.data
//     }).catch(() => {
//         dispatch({ type: CONSTANTS.GET_VEHICLE_FAILURE })
//     })
// }
// this function fetch country list 
// export const getcountryList = (code = '') => (dispatch) => {
//     dispatch(addEventLog(code, CONSTANTS.GET_VEHICLE_REQUEST))
//     dispatch({ type: CONSTANTS.GET_VEHICLE_REQUEST })
//     return getRequest(`${APICONFIG.getVehicleDetailsUrl}`).then((res) => {
//         let resObject = { ...res, code: code }
//         dispatch(addEventLog(resObject, CONSTANTS.GET_VEHICLE_SUCCESS))
//         let data = { ...res.data }
//         if (code) {
//             let country = data.country.filter((v) => code?.includes(v.country_code))

//             data['country'] = country
//         }
//         dispatch({ type: CONSTANTS.GET_VEHICLE_SUCCESS, data: data })
//         return data
//     }).catch((err) => {
//         let errObject = { ...err, code: code }
//         dispatch(addEventLog(errObject, CONSTANTS.GET_VEHICLE_FAILURE))
//         dispatch({ type: CONSTANTS.GET_VEHICLE_FAILURE })
//     })
// }

export const getVehicleDetailsList = () => (dispatch) => {
    // PIMS-10130
    dispatch({ type: CONSTANTS.GET_VEHICLE_REQUEST })
    return getRequest(`${APICONFIG.getVehicleDetailsUrl}`).then((res) => {
        let data = { ...res.data }
        const getuserDatafromLocal = JSON.parse(localStorage.getItem('partnerData'))
        const getAccessPermissionData = sortPortalPermissionByKey(getuserDatafromLocal, 'Access Permissions')
        const isAllowedCountry = (isPermissionExist(getAccessPermissionData, 'Partner Country Enabled')) ? [getuserDatafromLocal?.facilities?.[0]?.country_code] : [getuserDatafromLocal?.facilities?.[0]?.country_code, 'CA', 'GB']
        if (isAllowedCountry?.length > 0) {
            let country = data.country.filter((v) => isAllowedCountry?.includes(v.country_code))
            data['country'] = country
        }
        dispatch({ type: CONSTANTS.GET_VEHICLE_SUCCESS, data: data })
        return data
    }).catch(() => {
        dispatch({ type: CONSTANTS.GET_VEHICLE_FAILURE })
    })
}

// GET VEHICLE Model List
export const getVehicleModelList = (countryCode = '', countryId = '') => (dispatch) => {
    disposeItem(countryCode)
    // PIMS-10130
    // const payload = {
    //     countryCode: countryCode,
    //     countryId: countryId
    // }
    // dispatch(addEventLog(payload, CONSTANTS.GET_VEHICLE_MODEL_REQUEST))
    let apiUrls = `${APICONFIG.getVehicleModelUrl}`
    if (countryId && countryId != '') {
        apiUrls = `${APICONFIG.getVehicleModelUrl}/${countryId}`
    }
    dispatch({ type: CONSTANTS.GET_VEHICLE_MODEL_REQUEST })
    return getRequest(`${apiUrls}`).then((res) => {
        // let resObject = {...payload, ...res} 
        // dispatch(addEventLog(resObject, CONSTANTS.GET_VEHICLE_MODEL_SUCCESS))
        dispatch({ type: CONSTANTS.GET_VEHICLE_MODEL_SUCCESS, data: res.data })
        return res.data
    }).catch((error) => {
        // let errObject = {...payload, ...error} 
        // dispatch(addEventLog(errObject, CONSTANTS.GET_VEHICLE_MODEL_FAILURE))
        dispatch({ type: CONSTANTS.GET_VEHICLE_MODEL_FAILURE })
        return error
    })
}

export const postVehicleupdate = (data) => (dispatch) => {
    dispatch(addEventLog(data, CONSTANTS.POST_VEHICLE_LIST_REQUEST))
    dispatch({ type: CONSTANTS.POST_VEHICLE_LIST_REQUEST })
    return putRequest(APICONFIG.postVehicleUpdateUrl, data).then((res) => {
        let resObject = { ...data, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.POST_VEHICLE_LIST_SUCCESS))
        dispatch({ type: CONSTANTS.POST_VEHICLE_LIST_SUCCESS, data: res.data })
        return res
    }).catch((err) => {
        let errObject = { ...data, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.POST_VEHICLE_LIST_FAILURE))
        dispatch({ type: CONSTANTS.POST_VEHICLE_LIST_FAILURE })
        return err
    })
}

// GET VEHICLE Model List
export const getVehicleModelListPermission = (countryCode = '', countryId = '') => (dispatch) => {
    disposeItem(countryCode)
    // PIMS-10130
    let apiUrls = `${APICONFIG.getVehicleModelUrl}`
    if (countryId && countryId != '') {
        apiUrls = `${APICONFIG.getVehicleModelUrl}/${countryId}`
    }
    dispatch({ type: CONSTANTS.GET_VEHICLE_MODEL_REQUEST })
    return getRequest(`${apiUrls}`).then((res) => {
        let data = { ...res.data }
        const getuserDatafromLocal = JSON.parse(localStorage.getItem('partnerData'))
        const getAccessPermissionData = sortPortalPermissionByKey(getuserDatafromLocal, 'Access Permissions')
        const isAllowedCountry = (isPermissionExist(getAccessPermissionData, 'Partner Country Enabled')) ? [getuserDatafromLocal?.facilities?.[0]?.country_code] : [getuserDatafromLocal?.facilities?.[0]?.country_code, 'CA', 'GB']
    
        if (isAllowedCountry?.length > 0) {
            let country = data.country.filter((v) => isAllowedCountry?.includes(v.country_code))
            data['country'] = country
        }
        dispatch({ type: CONSTANTS.GET_VEHICLE_MODEL_SUCCESS, data: data })
        return data
    }).catch((error) => {
        // let errObject = {...payload, ...error} 
        // dispatch(addEventLog(errObject, CONSTANTS.GET_VEHICLE_MODEL_FAILURE))
        dispatch({ type: CONSTANTS.GET_VEHICLE_MODEL_FAILURE })
        return error
    })
}

